"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Card = _interopRequireDefault(require("@material-ui/core/Card"));
var _CardContent = _interopRequireDefault(require("@material-ui/core/CardContent"));
var _CardActions = _interopRequireDefault(require("@material-ui/core/CardActions"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _GroupAdd = _interopRequireDefault(require("@material-ui/icons/GroupAdd"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _styles = require("@material-ui/core/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _moment = _interopRequireDefault(require("moment"));
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _Carousel = _interopRequireDefault(require("../Carousel/Carousel"));
var _style = require("../../utils/style");
var _useBoatLowestPrice = require("../../hooks/useBoatLowestPrice");
var _useBoatOrderedImages = require("../../hooks/useBoatOrderedImages");
var _classnames = _interopRequireDefault(require("classnames"));
var _ = require("../..");
var _gatsbyPluginImage = require("gatsby-plugin-image");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
    mixins = _ref.mixins,
    typography = _ref.typography,
    spacing = _ref.spacing;
  return {
    boatRoot: {
      transition: "all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      "&:hover": {
        transform: "scale(1.03)"
      }
    },
    actionArea: {
      position: "relative"
    },
    media: {
      height: 0,
      paddingTop: "56.25%" // 16:9
    },

    mediaInner: {
      position: "absolute!important",
      top: 0,
      width: "100%",
      height: "100%"
    },
    imageWrap: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      objectPosition: "bottom"
    },
    actions: {
      color: palette.common.white,
      position: "absolute",
      bottom: 0,
      right: 0,
      textAlign: "right"
    },
    body: {
      height: 130,
      overflowY: "auto",
      overflowX: "hidden"
    },
    footer: {
      paddingTop: 0
    },
    itemFooter: {
      marginBottom: "-".concat(spacing(1), "px")
    }
  };
});
function PackageCard(_ref2) {
  var boat = _ref2.boat,
    boatPackage = _ref2.boatPackage,
    useNoneGatsbyImage = _ref2.useNoneGatsbyImage,
    _onClick = _ref2.onClick;
  var _useStyles = useStyles(),
    boatRoot = _useStyles.boatRoot,
    actionArea = _useStyles.actionArea,
    media = _useStyles.media,
    imageWrap = _useStyles.imageWrap,
    mediaInner = _useStyles.mediaInner,
    actions = _useStyles.actions,
    body = _useStyles.body,
    footer = _useStyles.footer,
    itemFooter = _useStyles.itemFooter;
  var featuredImg = (0, _react.useMemo)(function () {
    return boatPackage.media && boatPackage.media.mediaFiles ? boatPackage.media.mediaFiles[0].path : null;
  }, [boatPackage]);
  var image = (0, _gatsbyPluginImage.getImage)(featuredImg);
  return /*#__PURE__*/_react["default"].createElement(_Card["default"], {
    raised: true,
    elevation: 2,
    className: boatRoot
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: actionArea
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: media
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: mediaInner
  }, useNoneGatsbyImage ? /*#__PURE__*/_react["default"].createElement("img", {
    className: imageWrap,
    alt: "Package featured image",
    src: featuredImg
  }) : /*#__PURE__*/_react["default"].createElement(_gatsbyPluginImage.GatsbyImage, {
    image: image,
    loading: "lazy",
    alt: "Package featured image"
  })))), /*#__PURE__*/_react["default"].createElement(_CardContent["default"], null, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h5",
    color: "primary",
    component: "h2",
    noWrap: true
  }, (boat === null || boat === void 0 ? void 0 : boat.name) || "----"), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h6",
    color: "textPrimary",
    component: "h3",
    noWrap: true
  }, boatPackage.name || "----"), /*#__PURE__*/_react["default"].createElement("div", {
    className: body
  }, boatPackage.content && boatPackage.content !== "" ? /*#__PURE__*/_react["default"].createElement(_.EditorDisplay, {
    content: boatPackage.content
  }) : (boatPackage.description || "").split("\n").map(function (text, idx) {
    return /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      key: idx,
      variant: "body2"
    }, text);
  }))), /*#__PURE__*/_react["default"].createElement(_CardContent["default"], {
    className: footer
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    container: true,
    alignItems: "center",
    spacing: 1
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    xs: 7,
    item: true
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "contained",
    color: "primary",
    size: "small",
    onClick: function onClick() {
      return _onClick(boatPackage);
    },
    disableElevation: true
  }, "View Package & Book")), /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    xs: 5,
    item: true
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    color: "primary",
    variant: "h6"
  }, "$", (0, _.formatNumber)(boatPackage.price))))));
}
var _default = exports["default"] = PackageCard;